"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskImpression = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var nullTasks_1 = require("./nullTasks");
var taskImpression = function (event) {
    var task = event.eventData.task;
    if (!task || task.length === 0) {
        return (0, nullTasks_1.nullTasks)(event);
    }
    return {
        event: analytics_layer_1.TaskEventNames.TaskImpression,
        eventInfo: analytics_layer_1.TaskEventNames.TaskImpression,
        task: task.map(function (_a) {
            var taskName = _a.taskName, taskDisplayPosition = _a.taskDisplayPosition, productName = _a.productName;
            return ({
                taskName: taskName || consts_1.NOT_AVAILABLE,
                taskDisplayPosition: taskDisplayPosition !== null && taskDisplayPosition !== void 0 ? taskDisplayPosition : consts_1.NOT_AVAILABLE,
                productName: productName || consts_1.NOT_AVAILABLE,
            });
        }),
    };
};
exports.taskImpression = taskImpression;
